//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class RepertoirePerformanceInputItem extends ItemBase {
    Event: string | null = null;
    Grade: string | null = null;
    Note: string | null = null;
    PerformanceDate: string = "1970-01-01T00:00:00";
    RepertoireID: string | null = null;
    StudentID: string | null = null;

    constructor(initializer?: Partial<RepertoirePerformanceInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoirePerformanceInputItem";
}
